import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { FF_PATIENT_REFILL_CHECKOUT_BANNER, FF_PATIENT_REFILL_CHECKOUT_BANNER_TEXT } from '@/constants/featureFlags';
import ffDefaults from '@/constants/ffDefaults';
import useFeatureFlags from '@/hooks/useFeatureFlags';
import useCustomer from '@/hooks/user/useCustomer';
import { PATIENT_REFILL_ROUTE } from '@/routes/route-paths';
import { Alert, ViewObserver } from '@montugroup/design-system';

export const RefillCheckoutWarningBanner = ({ text }: { text: string }) => (
  <Alert
    severity="warning"
    sx={{
      width: '100%',
    }}
  >
    {text}
  </Alert>
);

export const PageBanner = () => {
  const { flags } = useFeatureFlags();
  const location = useLocation();
  const { data: customer } = useCustomer();

  const ffCheckoutBannerText =
    flags[FF_PATIENT_REFILL_CHECKOUT_BANNER_TEXT] || ffDefaults[FF_PATIENT_REFILL_CHECKOUT_BANNER_TEXT];
  const ffPatientRefillCheckoutBanner = flags[FF_PATIENT_REFILL_CHECKOUT_BANNER];

  const Banner = useCallback(() => {
    const shouldShowBanner = ffPatientRefillCheckoutBanner && location.pathname.includes(PATIENT_REFILL_ROUTE);

    if (!shouldShowBanner) {
      return null;
    }

    return (
      <ViewObserver id={`refill-checkout-warning-page-banner-${customer?.id ?? ''}`}>
        <RefillCheckoutWarningBanner text={ffCheckoutBannerText} />
      </ViewObserver>
    );
  }, [ffCheckoutBannerText, ffPatientRefillCheckoutBanner, location.pathname]);

  return <Banner />;
};
